module.exports = __webpack_public_path__ + "media/horse.9c0fedf0.mp3";